import { queueAnalyticsEvent } from 'lib/gtm/dataLayer'

////////////////////////////////////////////////
////////////////////Algolia/////////////////////
////////////////////////////////////////////////

export const algoliaInsightsUserTokenChange = (
  userToken: string | number | undefined
) => {
  if (!userToken) return

  queueAnalyticsEvent({
    event: 'algolia.user.token.change',
    algoliaUserToken: userToken
  })
}

interface AlgoliaInsightsHitsViewedData {
  objectIDs: string[]
  positions: number[]
  queryID: string | null
  userToken: string | undefined
}

export const algoliaInsightsHitsViewed = (
  hitsData: AlgoliaInsightsHitsViewedData
) => {
  queueAnalyticsEvent({ objectIDs: null, positions: null })
  queueAnalyticsEvent({ event: 'Hits Viewed', ...hitsData })
}
